export default (
    <svg width="51" height="52" viewBox="0 0 51 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.37891 45.1226L12.1525 50.8961C12.5329 51.2766 13.0476 51.5004 13.5847 51.5004H37.3951C37.9322 51.5004 38.4469 51.2766 38.8273 50.8961L44.6009 45.1226H6.37891Z"
            fill="#1522B0"
        />
        <path
            d="M44.6224 6.87731L38.8488 1.10372C38.4684 0.723294 37.9537 0.499512 37.4166 0.499512H13.6062C13.0691 0.499512 12.5544 0.723294 12.174 1.10372L6.40039 6.87731H44.6672H44.6224Z"
            fill="#1522B0"
        />
        <path
            d="M6.3778 6.87642L0.604212 12.65C0.223782 13.0304 0 13.5451 0 14.0822V37.8927C0 38.4297 0.223782 38.9444 0.604212 39.3249L6.3778 45.0984V6.87642Z"
            fill="#1522B0"
        />
        <path
            d="M44.6211 6.87646V45.1432L50.3947 39.3697C50.7751 38.9892 50.9989 38.4745 50.9989 37.9375V14.1046C50.9989 13.5676 50.7751 13.0529 50.3947 12.6724L44.6211 6.89884V6.87646Z"
            fill="#1522B0"
        />
        <path
            d="M20.5431 37.266L10.8757 27.5986C10.6743 27.3972 10.6743 27.0839 10.8757 26.8825L14.6576 23.1006C14.859 22.8992 15.1723 22.8992 15.3737 23.1006L21.2592 28.9861L35.6484 14.5969C35.8498 14.3954 36.1631 14.3954 36.3645 14.5969L40.1464 18.3788C40.3478 18.5802 40.3478 18.8935 40.1464 19.0949L21.9753 37.266C21.5725 37.6688 20.9235 37.6688 20.5431 37.266Z"
            fill="#1522B0"
        />
    </svg>
)
